const titles = ["Mr", "Mrs", "Miss", "Ms", "Mr & Mrs", "Dr", "Lord", "Lady"];
const phoneTypes = [{name: "Phone", typeCode: 0}, {name: "Mobile", typeCode: 3}];
const sexes = ["Male", "Female", "Unknown"];
const emailRegex = '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';

app.factory('SessionService', function ($q, $window) {
    'use strict';
    let data = {};
    data.sexes = sexes;
    data.error = null;
    data.titles = titles;
    const service = this;
    data.loading = false;
    data.navbarLoaded = false;

    return {
        emailRegex: emailRegex,
        mobileRegex: '(\\+44\\s?7\\d{3}|\\(?07\\d{3}\\)?)\\s?\\d{3}\\s?\\d{3}$',
        phoneTypes: phoneTypes,
        alphanumericRegex: "^[A-Za-z0-9 _\-]*[A-Za-z0-9\-][A-Za-z0-9 _\-]*$",

        getClientNumber: function (transferClient) {
            const deferred = $q.defer();
            Parse.Cloud.run("findClientForTransfer", transferClient
                , {}).then(result => {
                if (result.transferEntry) {
                    transferClient.transferEntry = result.transferEntry;
                    deferred.resolve(transferClient);
                } else if (result.errorCode) {
                    transferClient.errorCode = result.errorCode;
                    transferClient.message = {msg: result.errorMessage};
                    transferClient.clinic = result.clinic;
                    deferred.reject(transferClient);
                } else if (result.code && result.code === 204) {
                    transferClient.errorCode = 204;
                    transferClient.message = {msg: "Sorry, we’ve been unable to match your details to a customer record. Please check your details are correct and try again."};
                    deferred.reject(transferClient);
                }
            }, error => deferred.reject(error));
            return deferred.promise;
        },
        resendCode: function (transferId) {
            const deferred = $q.defer();
            Parse.Cloud.run("resendTransferCode", {transferId: transferId}
                , {}).then(() => deferred.resolve(), error => deferred.reject(error));
            return deferred.promise;
        },
        verifyContact: function (transferId, verificationCode) {
            const deferred = $q.defer();
            Parse.Cloud.run("verifyContactForTransfer", {
                    transferId: transferId,
                    verificationCode: verificationCode.toString()
                }
                , {}).then(function (result) {
                if (result.verified) {
                    deferred.resolve();
                } else {
                    deferred.reject("Unverified");
                }
            }, error => deferred.reject(error));
            return deferred.promise;
        },
        registerNavController: function (controller) {
            service.navController = controller;
        },
        getNavController: function () {
            return service.navController;
        },
        getClinicDetails: function (clinicCode) {
            const deferred = $q.defer();
            Parse.Cloud.run("getClinicDetails", {
                'clinicCode': clinicCode
            }, {}).then(result => {
                if (service && service.navController) {
                    data.isGroomRoom = result.groomRoom;
                    data.clinicDetails = result;
                    service.navController.setPreload(false);
                }
                deferred.resolve(result)
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        // getCurrentPosition: function () {
        //     const deferred = $q.defer();
        //     if (!$window.navigator.geolocation) {
        //         deferred.reject('Geolocation not supported.');
        //     } else {
        //         $window.navigator.geolocation.getCurrentPosition(
        //             function (position) {
        //                 deferred.resolve(position);
        //             },
        //             function (err) {
        //                 deferred.reject(err);
        //             });
        //     }
        //     return deferred.promise;
        // },
        findClinicsByPostcode: function (params) {
            const deferred = $q.defer();
            Parse.Cloud.run("getTransferClinicsByPostcode", params, {}).then(result => {
                data.clinicsList = result;
                deferred.resolve(result)
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        getClosingClinicList: function () {
            const deferred = $q.defer();
            Parse.Cloud.run("getTransferClinicList", {}, {}).then(result => {
                data.closingClinics = result;
                deferred.resolve(result)
            }, function (error) {
                console.log(error);
                this.error = error;
                deferred.resolve(result)
            });
            return deferred.promise;
        },
        finishWizard: function (transferDetails) {
            const deferred = $q.defer();
            Parse.Cloud.run("finishV4PTransfer", transferDetails, {}).then(() => {
                deferred.resolve("done");
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        data: data
    }
});
